import { gql } from '@parkchirp/api-client';

export const PROCESS_EXTERNAL_PAYMENT = gql`
    mutation processExternalPayment(
        $invoiceId: String!
        $paymentMetaId: String!
        $paymentType: String!
    ) {
        processExternalPayment(
            invoiceId: $invoiceId
            paymentMetaId: $paymentMetaId
            paymentType: $paymentType
        ) {
            invoiceId
        }
    }
`;

export const SAVE_CREDIT_CARD_V2 = gql`
    mutation saveCreditCard(
        $token: String!
        $paymentProviderId: Int!
        $cognitoSub: String
        $street: String
        $zip: String
    ) {
        saveCreditCard(
            token: $token
            cognitoSub: $cognitoSub
            paymentProviderId: $paymentProviderId
            street: $street
            zip: $zip
        ) {
            paymentMethodId
            token
            type
            last4
            expMonth
            expYear
        }
    }
`;

export type SaveCreditCardResult = {
	paymentMethodId: number;
	token: string;
	type: string;
	last4: string;
	expMonth: string;
	expYear: string;
};
